const updates = [
  { time: '10分钟前', text: '某电竞战队内部训练赛战绩遭泄露，核心选手疑似闹矛盾转会', tag: '电竞' },
  { time: '28分钟前', text: '网友实锤某综艺选秀节目淘汰名单提前流出，节目组紧急回应', tag: '综艺' },
  { time: '1小时前', text: '体育圈大瓜：某知名运动员被拍到深夜密会，疑似恋情曝光', tag: '体育' },
  { time: '2小时前', text: '51吃瓜爆料每日大赛最新动态：评委席突发争执，现场视频疯传', tag: '热点' },
  { time: '3小时前', text: '某音乐节阵容疑遭内部人员提前泄露，主办方称将追究法律责任', tag: '音乐' },
  { time: '5小时前', text: '电竞圈再曝大料：某冠军战队经理涉嫌违规操作被联盟调查', tag: '电竞' },
  { time: '7小时前', text: '51爆料每日大赛追踪：选手私下言论被曝光引发粉丝大战', tag: '热点' },
  { time: '9小时前', text: '某热门网剧大结局剧情提前外泄，制作方紧急启动保密排查', tag: '影视' },
  { time: '12小时前', text: '游戏圈地震：某大厂新项目核心玩法被前员工爆料，官方沉默', tag: '游戏' },
];

export default function Updates() {
  return (
    <section id="updates" className="section-py bg-background-50">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            最新快讯
          </h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">实时更新</span>
        </div>

        <div className="relative pl-6 border-l-2 border-primary-200 space-y-6">
          {updates.map((item, idx) => (
            <div key={idx} className="relative">
              <div className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3">
                <span className="text-xs text-foreground-500 whitespace-nowrap font-medium">{item.time}</span>
                <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                <p className="text-sm text-foreground-800 leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}